export default class DeviceIdentity {
  constructor ({ apiCall, logger }) {
    this.apiCall = apiCall
    this.logger = logger
  }

  registerToken () {
    this.logger.error('registerToken: method not implemented')
  }

  clearToken () {
    this.logger.error('clearToken: method not implemented')
  }
}
